import styled from 'styled-components';

type Props = {
  isDragAccept: boolean;
  isDragReject: boolean;
  isDragActive: boolean;
  children: JSX.Element;
};

const getColor = (props: Props) => {
  if (props.isDragAccept) {
    return '#00e676';
  }
  if (props.isDragReject) {
    return '#ff1744';
  }
  if (props.isDragActive) {
    return '#2196f3';
  }
  return '#eeeeee';
};

export const Container = styled.div<Props>`
  flex: 1;
  flex-grow: 3;
  display: flex;
  height: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 10px;
  border-width: 2px;
  border-radius: 8px;
  border-color: ${(props) => getColor(props)};
  border-style: solid;
  background-color: #f3f3f3;
  color: #bdbdbd;
  outline: none;
  transition: border 0.24s ease-in-out;
  cursor: pointer;
`;
